module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("ondon Transport’s L class of 263 ECW-bodied Leyland Olympians, comprising three evaluation and 260 production vehicles, brought an end to the pattern of yearly orders placed by that august organisation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Solid, reliable and with the kind of timeless attractiveness that came with ECW’s bodywork, the Leyland Olympian ought to have attracted custom from London Transport almost as soon as it was unveiled to replace all of the Leyland Atlantean, Daimler Fleetline and Bristol VRT, but for LT’s persistence with the Titan. In fact, the Olympian was everything the Titan should have been from the outset, with the critical option of allowing companies to choose their own bodywork.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Not merely due to the massive upheaval inflicted upon the capital’s bus services in the 1980s, London Transport’s Ls were the last London double-deckers to achieve a full lifespan, operating for nineteen years where subsequent generations have struggled to manage two-thirds of that. About the only downside to the Ls was the tinkering with the interior specification that produced the inefficient and space-consuming straight staircases and the split-step entrance doors, which while well-intentioned in aim, ended up just being a nuisance. And quite why they deleted the foglights from the specification of the production vehicles will never be known!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Other Olympians, included those drafted into the L class by post-London Buses Ltd operators, will be covered in a future volume, as will the Volvo-badged examples that took over from 1993 with even more success than the original Leyland models.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('b', [_c('i', [_vm._v("Matthew Wharmby")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Walton-on-Thames, September 2015")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("While all-red gave way to a variety of liveries as LBL gave way to the private sector, none was better than that carried by Plumstead’s L 136 (D136 FYM) between 1990 and 1995. It was commissioned to commemorate the fortieth anniversary of the departure of Woolwich Corporation Tramways, the route of which had been inherited by the modern route 180, and the bus was kept predominantly on that route. Complete with chromed numberplates where the rest of the class was delivered with black-on-white reflective versions, L 136 is seen towards the end of both its spell in this livery, and of ‘London Transport’ operations as a whole, at Crystal Palace during a visit to the 122 in 1994.")]), _vm._v(" "), _c('i', [_vm._v("Bill Young")])])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13383504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Introduction.vue
// module id = 72
// module chunks = 0